module.exports = __webpack_public_path__ + "img/man.284d3f23.jpg";